module.exports = __webpack_public_path__ + "img/platform-icon-3.e2b23142.png";